import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  wrap: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  game: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#add8e6',
    height: '100%',
    width: '100%',
    color: 'black',
    lineHeight: '50px',
  },
}));
